export default __webpack_public_path__ + "static/media/poster-mobile.68a9cd86.jpg";